import store from "@/store";
import getInfoTable from "@/util/infoTable";

export default {
  install(Vue) {
    // getInfoTable();
    Vue.prototype.$login = (
      username,
      password,
      newPassword,
      tokenTwoStepsAuth,
    ) => {
      // Endpoint
      const endpoint = Vue.prototype.$isAgent()
        ? "/agent/user/login"
        : `/player/user/login?db_name=${Vue.prototype.$domain()}`;

      // params
      const domain = Vue.prototype.$domain();
      const params = {
        login: username,
        password: password,
        operator_code: domain,
      };

      if (newPassword) {
        params.password_new = newPassword;
      } else if (tokenTwoStepsAuth) {
        params.token = tokenTwoStepsAuth;
      }

      return new Promise((resolve, reject) => {
        Vue.prototype.$axios
          .post(endpoint, Vue.prototype.$formdata(params))
          .then((success) => {
            const { data } = success;

            if (success.status === 202) {
              if (data.dados && data.dados.token_sent) {
                // Remover alert caso o usuário já tenha 2FA ativo
                localStorage.setItem("alertActivateTwoStepsAuthentication", true);

                store.commit("setDialogVerifySmsToken", {
                  status: true,
                  typeVerification: "twoStepsAuthentication",
                  login: username,
                  password,
                });

                store.commit("setNotification", {
                  msg: data.messages,
                  color: "success",
                });

                resolve({
                  statusCode: 202,
                  message: data.messages,
                  tokenTwoStepsAuth: data.dados.token_sent,
                });

                return;
              }

              if (data.dados && data.dados.renew_password) {
                store.commit("showChangePasswordDialog", true);
                store.commit("setNotification", {
                  msg: data.messages,
                  color: "warning",
                });

                resolve({
                  statusCode: 202,
                  message: data.messages,
                  renewPassword: data.renew_password,
                });

                return;
              }
            }

            // Config $Axios Headers Authorization
            Vue.prototype.$axios.defaults.headers.common[
              "Application-Authorization"
            ] = data.token_jwt;

            if (!Vue.prototype.$isAgent()) {
              const date = data.token_exp.replace(/-/g, "/");
              localStorage.setItem("tokenExpirationDate", JSON.stringify(date));
            }

            // Store Vues
            store.commit("setLogged", {
              status: true,
              token: data.token_jwt,
              data: data.user_data,
            });

            store.commit("showDialogGreetingsPromotionsFirstTime", true);
            store.commit("setCash", data.user_data.credito_atual);
            store.commit("setBonus", {
              value: data.user_data.balance_bonus,
              status: data.user_data.bonus_status,
            });
            store.commit("setAvailableBalance", data.user_data.available_balance);
            store.commit("setRestrictedBalance", data.user_data.restricted_balance);
            
            store.commit("setUserId", data.user_data.id_usuario);

            localStorage.setItem("currentUserLogin", username);

            // Store localStorage (Native)
            localStorage.setItem("auth", true);
            // Set Store Permisson reward fro Agent
            store.commit("permission_reward", data.user_data.permission_reward);
            // Result Bet from Agent Default
            const resultBetDefault =
              data.user_data.permission_reward == "1" ? "4" : "3";
            store.commit("setSelectResultBet", resultBetDefault);

            store.commit("setUserTimeLimit", data.user_data.tempo_atividade);
            localStorage.setItem("lastLogin", Math.round(Date.now() / 1000));

            store.commit(
              "setMessagesNotRead",
              data.user_data.total_notificacao
            );
            if (Vue.prototype.$isAgent()) {
              if (data.user_data.is_afilliate == "1") {
                getInfoTable();
              }
            }

            // Register User_ID from Analytics
            // https://developers.google.com/analytics/devguides/collection/ga4/user-id?technology=gtagjs#access_the_identifier
            gtag("config", "G-SGHE1CDZQZ", {
              user_id: data.user_data.id_usuario,
            });
            gtag("set", "user_properties", {
              crm_id: data.user_data.id_usuario,
            });

            resolve({
              statusCode: 200,
              message: "Login efetuado com sucesso!",
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    };

    Vue.prototype.$loginAutomatic = (data) => {
      // Config $Axios Headers Authorization
      Vue.prototype.$axios.defaults.headers.common[
        "Application-Authorization"
      ] = data.token_jwt;

      const date = data.token_exp.replace(/-/g, "/");
      localStorage.setItem("tokenExpirationDate", JSON.stringify(date));

      // Store Vuex
      store.commit("setLogged", {
        status: true,
        token: data.token_jwt,
        data: data.user_data,
      });
      store.commit("showDialogGreetingsPromotionsFirstTime", true);
      store.commit("setCash", data.user_data.credito_atual);
      store.commit("setBonus", {
        value: data.user_data.balance_bonus,
        status: data.user_data.bonus_status,
      });
      store.commit("setUserId", data.user_data.id_usuario);
      // Store localStorage (Native)
      localStorage.setItem("auth", true);
      // Set Store Permission reward fro Agent
      store.commit("permission_reward", data.user_data.permission_reward);
      // Result Bet from Agent Default
      const resultBetDefault =
        data.user_data.permission_reward == "1" ? "4" : "3";
      store.commit("setSelectResultBet", resultBetDefault);

      store.commit("setUserTimeLimit", data.user_data.tempo_atividade);
      localStorage.setItem("lastLogin", Math.round(Date.now() / 1000));

      store.commit("setMessagesNotRead", data.user_data.total_notificacao);
    };
  },
};
